import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { NotificationsService } from 'angular2-notifications';
import { SessionStorageService } from 'ngx-webstorage';

import { FormControl } from '@angular/forms';

import { ResourcesService } from '../../../../services/resources/resources.service';
import { EventsService } from '../../../../services/events/events.service';
import { LocalStorageService } from 'ngx-webstorage';

import * as moment from 'moment-timezone';

@Component({
  selector: 'modal-survey-plan',
  styleUrls: [('./modalCompleteDay.scss')],
  templateUrl: './modalCompleteDay.html'
})

export class ModalCompleteDay {

  modalHeader: string;
  private user: string = "";
  surveyPlan;
  personals;
  eventDate;
  timeChangeFrom;
  timeChangeTo;
  momentFrom;
  momentTo;
  dateRegister;

  dateChangeFrom = false;
  dateChangeTo = false;
  tipoH: string[] = [
    'Entrada',
    'Salida'
  ];
  public surveys = [];
  public surveySelected: FormControl;

  constructor(
    private activeModal: NgbActiveModal,
    private _notificationService: NotificationsService,
    private _sessionStorage: SessionStorageService,
    private _resourcesService: ResourcesService,
    private _localStorage: LocalStorageService,
    private _eventsService: EventsService
  ) {
    var user = _localStorage.retrieve('user_data');
    if (user != null)
      this.user = user;
      
    this.surveyPlan = {
      fecha: '',
      horaInicio: '',
      horaFin: '',
      id_usuario: '',
    };



    
    _resourcesService.getEncargado()
    .subscribe(
    (result) => {
      this.personals = result.results;
    },
    (error) => console.log(error)
    );
  }

  ngOnInit() {

  }

  public doCompleteDay() {
    if( this.surveyPlan.horaInicio > this.surveyPlan.horaFin )
      this.showError('La Hora de Inicio debe ser menor que la Hora de Fin');
    else {

      this._eventsService.confirmCompleteDayEvent(this.surveyPlan);
      this.activeModal.close();

      // this._resourcesService.completeDay(this.surveyPlan).subscribe(
      //   result => this.saveSurveyPlan(result),
      //   error => this.showError(error)
      // );
    }
  }

  private showError(error) {
    console.log(error)

    let mensaje = error;
    if( mensaje == null )
      mensaje = 'Error con los datos ingresados.'
    this._notificationService.error('Error', mensaje);
  }

  public closeModal() {
    this.activeModal.close();
  }

  public setMoment(my_moment: any, model: string): any {   
    if( model == 'event_date') {
      this.surveyPlan.fecha = moment(my_moment).format('YYYYMMDD');    
    }
    else if ( model == 'hour_from') {
      this.surveyPlan.horaInicio = moment(my_moment).format('HHmm')+'00'; 
    }
    else if ( model == 'hour_to')  {
      this.surveyPlan.horaFin = moment(my_moment).format('HHmm')+'00'; 
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/theme/components/modals/components/modalCompleteDay/modalCompleteDay.component.ts